<bn-account-detail-base [product]="product"
  [hostRef]="hostRef"
  [productNumberFormat]="productNumberFormat"
  [title1]="title1"
  [title2]="title2"
  [title3]="title3"
  [title4]="title4">

  <div details>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.minimumPayment">Minimum payment</strong></div>
      <div>
        {{ product?.additions?.minimumPmtDOP | bnCurrencyPipe:localCurrency }}
        <bn-semaphore-tooltip *ngIf="dopSemaphore.type"
          [text]="dopSemaphore.text"
          [type]="dopSemaphore.type"></bn-semaphore-tooltip>
      </div>
      <div>
        {{ product?.additions?.minimumPmtUSD | bnCurrencyPipe:foreignCurrency }}
        <bn-semaphore-tooltip *ngIf="usdSemaphore.type"
          [text]="usdSemaphore.text"
          [type]="usdSemaphore.type"></bn-semaphore-tooltip>
      </div>
    </div>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.statementBalance">Statement balance</strong></div>
      <div>{{ product?.additions?.lastBalanceDOP | bnCurrencyPipe:localCurrency }}</div>
      <div>{{ product?.additions?.lastBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
    </div>
  </div>

  <div detailsFooter>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.paymentDueDate">Payment date due</strong></div>
      <div *ngIf="product?.minimumPaymentDueDate != -1">{{ product?.minimumPaymentDueDate | bnEsDate }}</div>
      <div *ngIf="product?.minimumPaymentDueDate == -1">--</div>
    </div>
  </div>

  <div row2
    class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.availableCredit">Available credit</strong></div>
        <div>
          {{ product?.additions?.availableBalanceDOP | bnCurrencyPipe:localCurrency }}
        </div>
        <div>{{ product?.additions?.availableBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.inTransit">In transit</strong></div>
        <div>{{ product?.additions?.deferredBalanceDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.deferredBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.currentBalance">Current balance</strong></div>
        <div>{{ product?.additions?.totalBalanceDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.totalBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
      <div class="account-detail-base__item account-detail-base__item--blue">
        <div><strong i18n="@@product.details.creditLimit">Credit limit</strong></div>
        <div>{{ product?.additions?.creditLimitDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.creditLimitUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
  </div>

  <div row3
    class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastStatementDate">Last statement date</strong></div>
        <div *ngIf="product?.additions?.cutoffdate != -1">{{ product?.additions?.cutoffdate }}</div>
        <div *ngIf="product?.additions?.cutoffdate == -1">--</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.statementPaymentsToDate">
            Statement payments to date
          </strong>
          <bn-semaphore-tooltip class="ml-1"
            [text]="infoTooltipText"
            type="info"></bn-semaphore-tooltip>
        </div>
        <div>{{ product?.additions?.accumulatedPaymentsDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.accumulatedPaymentsUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastPaymentDate">Last payment date</strong></div>
        <div *ngIf="product?.additions?.lastPmtDate != -1">{{ product?.additions?.lastPmtDate | bnEsDate }}</div>
        <div *ngIf="product?.additions?.lastPmtDate == -1">--</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastPayment">Last payment</strong></div>
        <div>{{ product?.additions?.lastPmtAmountDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.lastPmtAmountUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
  </div>

  <div row4
    class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.overdueInstallments">Overdue installments</strong></div>
        <div>{{ product?.additions?.expiredFees | bnEmpty }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.overdueAmount">Overdue amount</strong></div>
        <div>{{ product?.additions?.feeAmountDueDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.feeAmountDueUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item account-detail-base__item--green">
        <div>
          <strong i18n="@@product.details.greenPointsAvailable">Green points available</strong>
        </div>
        <div>{{ parseGreenPoints(product?.additions?.currentBalancePoints) | number | bnEmpty:'--' }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.interestRate">Interest rate</strong></div>
        <div>{{ product?.additions?.accountInterestRateDOP | bnCurrencyPipe:localCurrency }}%</div>
        <div>{{ product?.additions?.accountInterestRateUSD | bnCurrencyPipe:foreignCurrency }}%</div>
      </div>
    </div>
  </div>


</bn-account-detail-base>